import { Location } from '@/domain/mitarbeiter/features/rotationsplan/components/Location';
import { KalenderArbeitsbereich as ArbeitsbereichType } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/kalenderByArbeitsbereiche/KalenderArbeitsbereich';

export function Arbeitsbereich({
  arbeitsbereich,
}: {
  arbeitsbereich: ArbeitsbereichType;
}) {
  return (
    <div className="sticky left-0 z-10 inline-flex flex-col justify-center items-start border-r border-solid border-neutrals-200 bg-white min-h-14">
      <div className="w-full px-1">
        <div className="px-0.5 w-44 inline-flex justify-start items-center gap-2">
          <div
            className="min-w-2.5 min-h-2.5 rounded-full"
            style={{ backgroundColor: arbeitsbereich.getBorderColor() }}
          />
          <div className="text-sm text-neutrals-900 truncate">
            {arbeitsbereich.name}
          </div>
        </div>
        <Location standort={arbeitsbereich.standort} />
      </div>
    </div>
  );
}
